module.exports = __webpack_public_path__ + "static/objavsk_logo-0473b1e5266bef75184132d8b09ad3d9.webp";